// import the library
import { library } from '@fortawesome/fontawesome-svg-core'

// import your icons
import { faExclamationTriangle, faDragon, faDungeon, faInfoCircle, faPause, faQuestion, faTrashAlt, faPlus, faLeaf, faLink, faTrophy, faUser, faSitemap, faEye, faBook, faCommentDots, faLightbulb, faBookOpen, faPlayCircle, faQuestionCircle, faCheckCircle, faImage, faShareAlt, faExclamationCircle, faPencilAlt, faArrowLeft, faTimes, faAngleRight, faAngleLeft, faAngleUp, faAngleDown, faHome, faSignOutAlt, faThLarge, faLock, faGlobe, faCog, faHeart, faTimesCircle, faSearch, faPhoneAlt, faFax, faEnvelope, faBolt, faHatWizard, faComments, faBriefcase, faSmileBeam, faBullhorn, faVideo, faQuoteLeft, } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare, faFacebookF, faTwitter, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faHeart as faHeartOutline } from '@fortawesome/free-regular-svg-icons'

library.add(
  faExclamationTriangle,
  faDragon,
  faDungeon,
  faInfoCircle,
	faPause,
	faQuestion,
  faTrashAlt,	
  faPlus,
  faLeaf,
  faLink,
  faTrophy,
  faUser, 
  faSitemap, 
  faEye, 
  faBook, 
  faCommentDots, 
  faLightbulb,
  faBookOpen,
  faPlayCircle,
  faQuestionCircle, 
  faCheckCircle,
  faImage,
  faShareAlt,
  faExclamationCircle,
  faPencilAlt,
  faArrowLeft,
  faTimes,
  faAngleRight, 
  faAngleLeft,
  faAngleUp,
  faAngleDown,
  faEnvelope,
  faHome,
  faSignOutAlt,
  faThLarge,
  faLock,
  faGlobe,
  faCog,
  faHeart,
  faTimesCircle,
  faSearch,
  faPhoneAlt,
  faFax,

  faFacebookSquare,
  faFacebookF,
  faTwitter,
  faInstagram, 
  faYoutube,

  faBolt, 
  faHatWizard, 
  faComments, 
  faBriefcase, 
  faSmileBeam, 
  faBullhorn,

  faVideo, 
  faQuoteLeft,
  faHeartOutline

)


// WEBPACK FOOTER //
// ./src/core/fonts/fontawesome.js